import React from 'react';

import { renderMoneyAmountShort } from '../../components/formBuilder/utility/renderValue';
import { formatLargeNumber } from '../../utility/formatNumbers';

export default function FlipKeyMetrics({ propertyData, userData }) {
  const cashNeeded = propertyData.totalCashInvestedOnPurchase;
  const totalProfit = propertyData.totalProfitFlip;
  // just to decimals
  const flipROI = (Math.round(propertyData.flipROI * 100) / 100).toFixed(2);
  const flipROIAnnualized = (
    Math.round(propertyData.flipROIAnnualized * 100) / 100
  ).toFixed(2);

  return (
    <section className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      <div className="relative">
        <div className="rounded-lg relative bg-white p-8 flex items-center justify-center gap-2 overflow-hidden h-full">
          <div className="flex flex-col items-center">
            <h3 className="text-md text-neutral-600">Cash Needed</h3>
            <div className="flex items-center gap-2">
              <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
                {renderMoneyAmountShort(cashNeeded)}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative">
        <div className="rounded-lg relative bg-white p-8 flex items-center justify-center gap-2 overflow-hidden h-full">
          <div className="flex flex-col items-center">
            <h3 className="text-md text-neutral-600">Total Profit</h3>
            <div className="flex items-center gap-2">
              <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
                {renderMoneyAmountShort(totalProfit)}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative">
        <div className="rounded-lg relative bg-white p-8 flex items-center justify-center gap-2 overflow-hidden h-full">
          <div className="flex flex-col items-center">
            <h3 className="text-md text-neutral-600">Flip ROI</h3>
            <div className="flex items-center gap-2">
              <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
                {flipROI}%
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="relative">
        <div className="rounded-lg relative bg-white p-8 flex items-center justify-center gap-2 overflow-hidden h-full">
          <div className="flex flex-col items-center">
            <h3 className="text-md text-neutral-600">Annualized ROI</h3>
            <div className="flex items-center gap-2">
              <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
                {flipROIAnnualized}%
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
